module.exports = __webpack_public_path__ + "img/comment-e-img.e5caaba2.png";